/** Tipo persona (PF/PM) y defaults laborales desde ficha de cliente. */

const REGIMEN_SOLO_PM = new Set(["601", "603", "620", "622", "623", "624"]);
const REGIMEN_SOLO_PF = new Set(["605", "606", "607", "608", "611", "612", "614", "615", "616", "621", "625"]);

export function regimenFiscalCode(regimenFiscal) {
  const m = String(regimenFiscal || "").trim().match(/^(\d{3})/);
  return m ? m[1] : "";
}

/**
 * Prioriza longitud de RFC (13 = PF, 12 = PM): corrige fichas donde tipo_persona
 * quedó mal (p. ej. «moral» tras parseo CSF) y el CURP no se mostraba.
 */
export function inferTipoPersona(cliente) {
  if (!cliente) return "moral";
  const rfc = String(cliente.rfc || "").replace(/\s/g, "").toUpperCase();
  if (rfc.length === 13) return "fisica";
  if (rfc.length === 12) return "moral";
  const explicit = String(cliente.tipo_persona || "").trim().toLowerCase();
  if (explicit === "fisica" || explicit === "moral") return explicit;
  const code = regimenFiscalCode(cliente.regimen_fiscal);
  if (REGIMEN_SOLO_PM.has(code)) return "moral";
  if (REGIMEN_SOLO_PF.has(code)) return "fisica";
  return "moral";
}

export function isPersonaMoral(cliente) {
  return inferTipoPersona(cliente) === "moral";
}

/** Mostrar campo CURP: persona física o ya hay CURP capturado. */
export function shouldShowClientCurp(cliente) {
  if (!cliente) return false;
  if (inferTipoPersona(cliente) === "fisica") return true;
  return Boolean(String(cliente.curp || "").trim());
}

export function laborDefaultsFromClient(cliente) {
  if (!cliente) return {};
  const moral = isPersonaMoral(cliente);
  const base = {
    razon_social_imss: cliente.razon_social || "",
    domicilio_patron: cliente.direccion || "",
    municipio_patron: cliente.municipio || "",
    estado_patron: cliente.estado || "",
    telefono_patron: cliente.telefono || "",
    correo_patron: cliente.email || "",
    actividad_patron: cliente.actividad_economica || "",
  };
  if (moral) {
    base.representante_legal = cliente.representante_legal || "";
    base.cargo_representante = cliente.cargo_representante || "";
  }
  return base;
}

/** Datos del prestador REPSE (cliente de trabajo) — solo lectura en UI. */
export function prestadorRepseFromClient(cliente) {
  if (!cliente) return null;
  return {
    rfc: cliente.rfc || "",
    razon_social: cliente.razon_social || "",
    domicilio_fiscal: cliente.direccion || "",
    municipio: cliente.municipio || "",
    estado: cliente.estado || "",
    actividad_economica: cliente.actividad_economica || "",
  };
}

/** Ya no precarga contratante con datos del prestador (roles distintos en REPSE). */
export function repseDefaultsFromClient() {
  return {};
}

export function mergeClientDefaults(form, defaults) {
  const next = { ...form };
  Object.entries(defaults || {}).forEach(([key, val]) => {
    if (val && !String(next[key] || "").trim()) {
      next[key] = val;
    }
  });
  return next;
}
